import {
    IPrivateRoute, PrivateRoute as PTVNPrivateRoute
} from "@ptvn-react/authentication";
import { default as React } from "react";

export const PrivateRoute: React.FC<Omit<IPrivateRoute, "publicKeyURL">> = (
  props
) => {
  return <PTVNPrivateRoute {...props} />;
};
